<script>
    //   <Card><h3>Why SkinGenie picked this</h3>…</Card>
    //   <Card tone="caution">…</Card>
    //   <Card href="/product/123">…</Card>
    //
    // `tone` tints a 1px rule along the top edge, for cards that carry a
    // verdict (the routine analyzer returns caution / danger).
    //
    // Two ways to make a card clickable, and the difference matters:
    //
    //   href        the WHOLE card becomes one <a>. Use only when the card
    //               contains no other links or buttons. A control nested
    //               inside an anchor is invalid HTML, is announced wrong by
    //               screen readers, and double-fires on click.
    //
    //   interactive hover affordance ONLY. No role, no tabindex. Use this for
    //               product cards, which carry their own "Buy" link. The card
    //               looks reactive; the real control inside stays the target.
    //
    // An earlier version of this component put role="button" + tabindex="0" on
    // the wrapper, which produced exactly the nested-control bug described
    // above the moment a card held a link.

    export let tone = 'default';    // default | success | caution | danger
    export let href = null;
    export let interactive = false;
    export let padded = true;
    export let elevated = false;

    $: hoverable = interactive || !!href;
</script>

<style>
    .card {
        position: relative;
        display: block;
        background: var(--surface);
        border: 1px solid var(--border);
        border-radius: var(--radius-0);
        color: inherit;
        text-decoration: none;
        transition:
            border-color var(--transition),
            background var(--transition);
    }

    .padded { padding: var(--card-pad); }
    .elevated { box-shadow: var(--shadow-2); }

    .hoverable:hover {
        border-color: var(--border-strong);
        background: var(--surface-2);
    }

    a.card { cursor: pointer; }

    /* A 1px rule along the top edge, in the tone's colour. */
    .success { border-top-color: var(--success); }
    .caution { border-top-color: var(--caution); }
    .danger  { border-top-color: var(--danger); }
</style>

{#if href}
    <a
        {...$$restProps}
        {href}
        class="card {tone}"
        class:padded
        class:elevated
        class:hoverable
        on:click
    >
        <slot />
    </a>
{:else}
    <div
        {...$$restProps}
        class="card {tone}"
        class:padded
        class:elevated
        class:hoverable
    >
        <slot />
    </div>
{/if}
